import React from 'react'

const AccountReports = () => {

    return (
      <><section className="content-header">
            <h1>Accounts Report</h1>
        </section><section className="content">
                <div className="box">
                    <div className="box-body">
                        <div className="panel panel-default panel-br-4">
                            <div className="panel-heading">
                                <div className="row">
                                    <div className="col-sm-6">
                                        <h4 className="panel-title">
                                            <i className="fa fa-file-text" aria-hidden="true"></i>
                                            <span> Accounts Reports</span>
                                        </h4>
                                    </div>
                                    <div className="col-sm-3" style={{ display: "flex" }}>
                                        <a className="btn btn-warning mr-10">
                                            <span>View Details</span>
                                        </a>
                                        <a className="btn btn-warning">
                                            <i className="fa fa-chevron-circle-down" aria-hidden="true"></i>
                                        </a>
                                    </div>
                                    <div className="col-sm-3">
                                        <a id="document-сreate-btn" className="btn btn-success mr-10" data-url="">
                                            <i className="fa fa-plus-circle"></i>
                                             <span>Generate PDF Report</span>
                                        </a>
                                    </div>
                                </div>
                            </div>

                            <div className="panel-body">
                                <p>No Report for Accounts</p>
                            </div>
                            <div className="panel-footer"></div>
                        </div>
                    </div>
                </div>
            </section></>
    )
}

export default AccountReports